import Header from '../Components/Header'
import Footer from '../Components/Footer';
import {
    useNavigate
} from 'react-router-dom';

const Welcome = () => {


    const navigate = useNavigate();
    // error handling click event
    const onTapped = () => {
        navigate('/survey/question1')
    }
    return ( <
        div className = "main-body" >
        <
        Header > < /Header> 
        
        <div class="welcomegreet">
        <h3><b>Hello 👋</b>
        <br /></h3>
            <p>
          

Thanks for visiting the Nigeria Customer Service Index website.
<br /><br />
Customer service/experience is at its lowest ebb and we can’t afford to let it go beyond this. Poor service quality have led to death, loss of revenue, mistrust in private and public sectors.
<br /><br />
Hopefully, this survey and its report thereafter will help stop the slide and improve service quality.
<br /><br />
Should you elect to take the survey, please give honest submission and do this without bias as this will help organizations in the twelve (12) sectors in the survey grow and improve on quality of service going forward.
<br /><br />
Thank You.
            </p>
        </div>
        
        <
        Footer onTap = {
            onTapped
        }
        title = {
            "Begin"
        }
        button_state = 'false'
        load = {
            '12%'
        }
        page = {
            1
        } > < /Footer> <
        /div>
    );
}

export default Welcome;